import React from 'react';
import { Chip } from '@toqio/toqio-web-components';
import { statusLabel, statusVariant } from '../status';

/**
 * Payment status pill (PRD §6/O-2). Shared by the list rows (`status`) and the
 * detail header (`paymentStatus`); both go through the one status map. Defaults
 * to the DS `m` size (lum-web never downsizes its `Chip`).
 */
export const StatusChip: React.FC<{ status: string; size?: 'm' | 's' }> = ({
  status,
  size = 'm',
}) => (
  <Chip size={size} variant={statusVariant(status)}>
    {statusLabel(status)}
  </Chip>
);
